import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

import { ADD_PLUS_LENGTH, ADD_PLUS_ICON_WIDTH } from './constants';

const AddButton = ({ isExpanded }) => (
  <span className="AddButton">
    <div
      className={classNames('AddButton__plus', {
        'AddButton__plus--expanded': isExpanded,
      })}
    />
    <style jsx>
      {`
        .AddButton {
          display: inline-block;
          border: 0;
          background: none;
          cursor: pointer;
        }

        .AddButton:focus {
          outline: none;
        }

        .AddButton.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }

        .AddButton__plus {
          position: relative;
          display: inline-block;
          width: ${ADD_PLUS_LENGTH}px;
          height: ${ADD_PLUS_LENGTH}px;
        }

        .AddButton__plus:before,
        .AddButton__plus:after {
          position: absolute;
          content: '';
          display: block;
          right: ${ADD_PLUS_LENGTH / 2}px;
          background-color: ${Theme.get('colors-black')};
          width: ${ADD_PLUS_ICON_WIDTH}px;
          height: ${ADD_PLUS_LENGTH}px;
          transition:
            background-color linear ${Theme.get('transition-duration-ms')},
            transform ease-in-out ${Theme.get('transition-duration-ms')};
        }

        .AddButton__plus:after {
          transform: rotate(90deg);
        }

        .AddButton__plus--expanded:before {
          transform: rotate(90deg);
          transform: ease-in-out ${Theme.get('transition-duration-ms')};
        }
      `}
    </style>
  </span>
);

AddButton.propTypes = {
  isExpanded: PropTypes.bool,
};

AddButton.defaultProps = {
  isExpanded: '',
};

export default AddButton;
